import { useLang } from "../context/LanguageContext";
import { FadeUp, InviewMaskLine } from "../components/Reveal";

export default function Process() {
  const { t } = useLang();
  return (
    <div className="bg-[#050607]" data-testid="process-page">
      <section className="px-5 md:px-10 pt-40 pb-20 md:pt-48 md:pb-24 border-b border-white/10">
        <FadeUp><div className="eyebrow mb-8">{t("process.eyebrow")}</div></FadeUp>
        <h1 className="font-display text-[36px] sm:text-[54px] lg:text-[68px] text-[#F3F3F0] max-w-5xl">
          {t("process.title").split("\n").map((l, i) => <InviewMaskLine key={i} delay={0.2 + i * 0.14} className={i === 1 ? "text-[#999995]" : ""}>{l}</InviewMaskLine>)}
        </h1>
        <FadeUp delay={0.35}><p className="mt-8 text-[15px] text-[#999995]">{t("process.sub")}</p></FadeUp>
      </section>

      <section className="px-5 md:px-10 py-20 md:py-28">
        <div className="relative max-w-4xl mx-auto">
          <div className="absolute left-[19px] md:left-1/2 top-0 bottom-0 w-px bg-white/10 md:-translate-x-1/2" />
          <div className="space-y-14 md:space-y-20">
            {t("process.stages").map((s, i) => (
              <FadeUp key={s.t} delay={0.05} className="relative grid grid-cols-[40px_1fr] md:grid-cols-2 gap-6 md:gap-16 items-start" data-testid={`process-stage-${i + 1}`}>
                <div className="relative z-10 flex justify-center pt-1">
                  <div className={`flex items-center justify-center w-10 h-10 rounded-full border bg-[#050607] ${i === 0 ? "border-[#D1C7BD]" : "border-white/15"}`}>
                    <span className="mono text-[10px] text-[#D1C7BD]">{String(i + 1).padStart(2, "0")}</span>
                  </div>
                </div>
                <div className={`md:text-right ${i % 2 === 1 ? "md:order-first md:text-left" : ""}`}>
                  <div className="hidden md:block mono text-[10px] tracking-[0.3em] text-[#555654] mb-3">STAGE {String(i + 1).padStart(2, "0")}</div>
                  <h2 className="mono text-[13px] md:text-[15px] tracking-[0.2em] text-[#F3F3F0] mb-3">{s.t}</h2>
                  <p className="text-[13px] md:text-[14px] leading-relaxed text-[#8A8A86] max-w-md md:inline-block">{s.d}</p>
                </div>
              </FadeUp>
            ))}
          </div>
        </div>
      </section>

      <section className="px-5 md:px-10 pb-24">
        <FadeUp>
          <div className="max-w-4xl mx-auto border border-white/10 bg-[#090A0B] p-6 md:p-8" data-testid="process-disclaimer">
            <div className="eyebrow mb-3">DISCLAIMER</div>
            <p className="text-[13px] leading-relaxed text-[#8A8A86]">{t("process.disclaimer")}</p>
          </div>
        </FadeUp>
      </section>
    </div>
  );
}
